<template>
  <main class="app-main">
    <keep-alive>
      <router-view />
    </keep-alive>
  </main>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'Dashboard',

    computed: {
        ...mapState('account', {
            userRole: state => state.userRole,
        }),

        isWeboAdmin() {
            return this.userRole === 'webo_admin'
        },

        isWeboEmployee() {
            return this.userRole === 'webo_employeee'
        },
    }
}
</script>
